import {  BoundingBoxAnchorResult, ClaimReferenceAnchorResult } from "@shared/models/common";

// explicit references have ref citation text, implicit references don't (they must have ref doc and at least one anchor)
export type ClaimReferenceType = 'EXPLICIT' | 'IMPLICIT';

export class ClaimReferenceDetails {

  refPhraseText!: string;
  refDocId!: number;
  anchors?: (BoundingBoxAnchorResult | ClaimReferenceAnchorResult)[];
  isConsistencyGenerated?: boolean;
  alreadyExists: boolean = false
  referenceType: ClaimReferenceType = 'EXPLICIT';



}
